import { horizontalRule, horizontalRuleContainer } from './HorizontalRule.css';

export const HorizontalRule = () => {
  return (
    <div className={horizontalRuleContainer}>
      <div className={horizontalRule} />
    </div>
  );
};
